// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__HG6vc","image":"Header_image__283sU","name":"Header_name__AR5Ch","info":"Header_info__3uEh7","infoRow":"Header_infoRow__3OAR1"};